<template>
  <section class="quote-info">
    <div class="box">
      <div class="table mg-b-10">
        <div class="tr">
          <span>Insured Period</span>
          <span
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</span>
        </div>
        <div class="tr">
          <span>Expected Insured Period</span>
          <span v-copy="formData.period_date">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </span>
        </div>
        <div class="tr">
          <span>Total Price</span>
          <span
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</span>
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span
            v-if="referrer"
            class="flex-column">
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                class="referrer"
                @click="handlerUser(referrer.id)">
                {{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}
              </span>
            </router-link>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <!--        <div-->
        <!--          v-if="formData.discount_str"-->
        <!--          class="tr">-->
        <!--          <span>Referrer Discount</span>-->
        <!--          <span>{{formData.discount_str}}</span>-->
        <!--        </div>-->
        <div
          v-if="!isEndorse"
          class="tr">
          <span>Policy Number </span>
          <span
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>Endorsement Number </span>
          <span
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span>Policy Reference Code </span>
          <span
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Amount</span>
        </div>
        <div
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <span>{{ inItem.item }}</span>
          <span v-copy="inItem.premium">{{ inItem.premium }}</span>
        </div>
        <div class="tr">
          <span>Excess Remark</span>
          <span
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></span>
        </div>
      </div>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <div
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <div
            v-if="excessIndex==0"
            class="tr th">
            <span>Item</span>
            <span>Information</span>
          </div>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span v-copy="subItem.premium">{{ subItem.premium }}</span>
          </div>
          <div class="tr">
            <span>Coverage Remark</span>
            <span
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <h3>Policy Detail</h3>
      <div class="table mg-b-10">
        <div class="tr">
          <span>Expected Effective Date</span>
          <span
            v-copy="formData.pcy_cmnt_date"
            :class="{'green-tip':handleCompare('pcy_cmnt_date')}">{{ formData.pcy_cmnt_date }}</span>
        </div>
        <div class="tr">
          <span>Expected Expiry Date</span>
          <span
            v-copy="formData.pcy_expry_date"
            :class="{'green-tip':handleCompare('pcy_expry_date')}">{{ formData.pcy_expry_date }}</span>
        </div>
        <div class="tr">
          <span>Contract Period</span>
          <span
            v-copy="getAllOptionName24('period', formData.contr_prd)"
            :class="{'green-tip':handleCompare('contr_prd')}">{{ getAllOptionName24('period', formData.contr_prd) }}</span>
        </div>
        <div class="tr">
          <span>Building Age </span>
          <span
            v-copy="getAllOptionName24('bldg_ages', formData.bldg_age)"
            :class="{'green-tip':handleCompare('bldg_age')}">{{ getAllOptionName24('bldg_ages', formData.bldg_age) }}</span>
        </div>
        <div class="tr">
          <span>Total Contract Sum </span>
          <span
            v-copy="formData.tol_contr_sum"
            :class="{'green-tip':handleCompare('tol_contr_sum')}">{{ formData.tol_contr_sum }}</span>
        </div>
        <div class="tr">
          <span>Material Damage Coverage </span>
          <span
            v-copy="getOptionName('yesNoOptions', formData.mat_dam_cvr_ind)"
            :class="{'green-tip':handleCompare('mat_dam_cvr_ind')}">{{ getOptionName('yesNoOptions', formData.mat_dam_cvr_ind) }}</span>
        </div>
        <div class="tr">
          <span>Third Party Liability Coverage </span>
          <span
            v-copy="getOptionName('yesNoOptions', formData.tp_lia_cvr_ind)"
            :class="{'green-tip':handleCompare('tp_lia_cvr_ind')}">{{ getOptionName('yesNoOptions', formData.tp_lia_cvr_ind) }}</span>
        </div>
        <div class="tr">
          <span>Third Party Liability Limit</span>
          <span
            v-copy="getAllOptionName24('limit_of_liability', formData.tppd_limit_amt)"
            :class="{'green-tip':handleCompare('tppd_limit_amt')}">{{ getAllOptionName24('limit_of_liability', formData.tppd_limit_amt) }}</span>
        </div>
        <div class="tr">
          <span>Outdoor Work or Scaffolding Work</span>
          <span
            v-copy="getOptionName('yesNoOptions', formData.outdoor_wk_ind)"
            :class="{'green-tip':handleCompare('outdoor_wk_ind')}">{{ getOptionName('yesNoOptions', formData.outdoor_wk_ind) }}
          </span>
        </div>
        <div class="tr">
          <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
          <span
            v-copy="getAllOptionName24('scaffolding_wk', formData.scaffolding_wk)"
            :class="{'green-tip':handleCompare('scaffolding_wk')}">{{ getAllOptionName24('scaffolding_wk', formData.scaffolding_wk) }}</span>
        </div>
        <div class="tr">
          <span>Employee Compensation</span>
          <span
            v-copy="getOptionName('yesNoOptions', formData.employee_ind)"
            :class="{'green-tip':handleCompare('employee_ind')}">{{ getOptionName('yesNoOptions', formData.employee_ind) }}</span>
        </div>
        <div
          v-if="option_benefits.length>0"
          class="tr">
          <span>Optional Benefits</span>
          <span>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index"
              v-copy="item.item">{{item.item}}<br></span>
          </span>
        </div>
      </div>
    </div>

    <div class="box">
      <h3>Policyholder Detail</h3>
      <div class="table">
        <template v-if="formData.cust_typ == 1">
          <div class="tr">
            <span>Title</span>
            <span
              v-copy="getOptionName('titleOptions', formData.isrd_title)"
              :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
          </div>
          <div class="tr">
            <span>Last Name</span>
            <span
              v-copy="formData.isrd_lst_nm"
              :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</span>
          </div>
          <div class="tr">
            <span>First Name</span>
            <span
              v-copy="formData.isrd_fst_nm"
              :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</span>
          </div>
          <div class="tr">
            <span>HKID</span>
            <span
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</span>
          </div>
          <div class="tr">
            <span>Mobile Number</span>
            <span
              v-copy="formData.mobile_no"
              :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</span>
          </div>
          <div class="tr">
            <span>Email</span>
            <span
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Occupation</span>
            <span
              v-copy="formData.occ"
              :class="{'green-tip':handleCompare('occ')}">{{  formData.occ }}</span>
          </div>
        </template>
        <template v-else>
          <div class="tr">
            <span>Company Name</span>
            <span
              v-copy="formData.isrd_com_nm"
              :class="{'green-tip':handleCompare('isrd_com_nm')}">{{ formData.isrd_com_nm }}</span>
          </div>
          <div class="tr">
            <span>Business Registration Number</span>
            <span
              v-copy="formData.id_no"
              :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</span>
          </div>
          <!-- <div class="tr">
            <span>CI Number</span>
            <span>{{ formData.ci_no }}</span>
          </div> -->
          <div class="tr">
            <span>Company Phone No.</span>
            <span
              v-copy="formData.phone_no"
              :class="{'green-tip':handleCompare('phone_no')}">{{ formData.phone_no }}</span>
          </div>
          <div class="tr">
            <span>Company Email</span>
            <span
              v-copy="formData.email"
              :class="{'green-tip':handleCompare('email')}">
              {{ formData.email }}
              <email-tooltip :email="formData.email"></email-tooltip>
            </span>
          </div>
          <div class="tr">
            <span>Nature of Business</span>
            <span
              v-copy="getAllOptionName24('industry', formData.bsns_nature_id)"
              :class="{'green-tip':handleCompare('bsns_nature_id')}">{{ getAllOptionName24('industry', formData.bsns_nature_id) }}</span>
          </div>
        </template>
      </div>
    </div>

    <div class="box">
      <h3>Correspondence Address	</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span
            v-copy="formData.addr_building"
            :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <h2>Work Details</h2>
      <h3>Location of Works</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span
            v-copy="formData.work_addr_room"
            :class="{'green-tip':handleCompare('work_addr_room')}">{{ formData.work_addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span
            v-copy="formData.work_addr_floor"
            :class="{'green-tip':handleCompare('work_addr_floor')}">{{ formData.work_addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span
            v-copy="formData.work_addr_block"
            :class="{'green-tip':handleCompare('work_addr_block')}">{{ formData.work_addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span
            v-copy="formData.work_addr_building"
            :class="{'green-tip':handleCompare('work_addr_building')}">{{ formData.work_addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span
            v-copy="formData.work_addr_street"
            :class="{'green-tip':handleCompare('work_addr_street')}">{{ formData.work_addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span :class="{'green-tip':handleCompare('work_addr_district')}">{{ getAreaName('district', formData.work_addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span v-copy="formData.work_addr_area">{{ getAreaName('area', formData.work_addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span
            v-copy="getAreaName('region', formData.work_addr_region)"
            :class="{'green-tip':handleCompare('work_addr_region')}">{{ getAreaName('region', formData.work_addr_region) }}</span>
        </div>
        <div class="tr">
          <span>Occupied as</span>
          <span
            v-copy="getAllOptionName24('occupied_as', formData.occupied_as)"
            :class="{'green-tip':handleCompare('occupied_as')}">{{ getAllOptionName24('occupied_as', formData.occupied_as) }}</span>
        </div>
      </div>
    </div>
    <div class="box">
      <h3>Sub-Contractor (if any)</h3>
      <div class="table">
        <div class="tr">
          <span>Sub Contractors (if any)</span>
          <span
            v-copy="formData.sub_contractors"
            :class="{'green-tip':handleCompare('sub_contractors')}">{{ formData.sub_contractors }}</span>
        </div>
        <div class="tr">
          <span>Property Management Company (If any)</span>
          <span
            v-copy="formData.property_management_company"
            :class="{'green-tip':handleCompare('property_management_company')}">{{ formData.property_management_company }}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h3>Remark(s)</h3>
      <div class="table">
        <div class="tr">
          <span>Remark</span>
          <span
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></span>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import OMath from '@/utils/math'

export default {
  name: 'DecorationPolicyInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed:{
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  methods:{
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
  }
}
</script>
<style lang="scss" scoped>
.quote-info{
  .box {
    margin-bottom: 15px;
  }
   .title {
    padding: 15px 0;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
